import { useEffect, useState, useMemo } from 'react'

import { getLandingDomains } from 'api'

import HeaderBox from 'component/PageModalHeaderBox'

import {
  Content,
  Wrapper,
  ContentTitle,
  TitleImg,
  QRCodeWrapper,
  ContentLink,
  CopyButton,
  DownloadButton,
  ContentWrapper,
  HeaderWrapper,
  ContentItems,
  ScrollContainer,
} from 'page/SharePage/Styled'
import { PageWrapperNonScroll } from 'commonStyledComponents'
import QRCode from 'qrcode.react'
import { BeatLoader } from 'react-spinners'
import { useToastAlert } from 'hooks/useToastAlert'
import PageLoading from 'component/Loading/PageLoading'
import useOpenModal from 'page/SharePage/hooks/useOpenModal'

interface SharePanelProps {
  /** 是否可載入推廣網域；路由頁傳 pageActivated，彈窗開啟即為 true */
  active: boolean
  videoShareUrl?: string
  /** 左上關閉；close 為 PageModalHeaderBox 預設的返回上一頁 */
  onClose: (params: { close: () => void }) => void
}

/** 分享推廣內容（QR code／複製連結／保存圖片），由 /share 路由頁與全屏分享彈窗共用 */
export default function SharePanel({ active, videoShareUrl, onClose }: SharePanelProps) {
  const { toast } = useToastAlert()
  const [landingPage, setLandingPage] = useState<any>(null)
  const [loading, setLoading] = useState(!videoShareUrl)
  const { openShareCard } = useOpenModal()

  const link = useMemo(() => {
    if (videoShareUrl) return videoShareUrl
    return landingPage ? landingPage.domain_name : ''
  }, [videoShareUrl, landingPage])

  async function handleCopy() {
    try {
      if (link && navigator.clipboard) {
        await navigator.clipboard.writeText(link)
        toast('已复制链接成功')
      }
    } catch (ex) {
      console.warn('copy text error', ex)
    }
  }

  async function handleDownload() {
    openShareCard(link)
  }

  async function loadPage(signal: AbortSignal) {
    try {
      setLoading(true)
      const res = await getLandingDomains({ signal, user_name_eq: 'share' })
      if (res?.data?.length) {
        const url = res.data.find((m: any) => m.domain_name)
        setLandingPage(url)
      }
    } catch {
      console.log('fetch url error')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!active || videoShareUrl) {
      return
    }
    const controller = new AbortController()
    const signal = controller.signal
    loadPage(signal)
    return () => {
      controller.abort()
    }
  }, [active, videoShareUrl])

  return (
    <PageWrapperNonScroll>
      <Wrapper>
        <HeaderWrapper>
          <HeaderBox
            headerTitle={''}
            onClose={onClose}
          />
        </HeaderWrapper>
        {!loading ? (
          <ScrollContainer>
            <TitleImg></TitleImg>
            <ContentWrapper>
              <Content>
                <ContentItems>
                  <ContentTitle>扫描二维码 下载APP立即观看</ContentTitle>
                  <QRCodeWrapper>
                    {!!link ? (
                      <QRCode id={'qrcode'} style={{ width: '2.64rem', height: '2.64rem' }} value={link} level={'H'} />
                    ) : (
                      <BeatLoader size={10} />
                    )}
                  </QRCodeWrapper>
                  <div>如果在微信扫码不能打开, 手动</div>
                  <div>在浏览器输入推广链结打开</div>
                  <ContentLink>{link}</ContentLink>
                  <CopyButton onClick={handleCopy}>复制分享链接</CopyButton>
                  <DownloadButton onClick={handleDownload}>保存图片分享</DownloadButton>
                </ContentItems>
              </Content>
            </ContentWrapper>
          </ScrollContainer>
        ) : (
          <PageLoading></PageLoading>
        )}
      </Wrapper>
    </PageWrapperNonScroll>
  )
}
